import { applyMiddleware, createStore } from "redux";
import rootReducer from "../reducers";
import api from "../middleware/api";
import { persistStore } from "redux-persist";
import history from "../history";
import { routerMiddleware } from "connected-react-router";

const configureStore = (initialState) => {
  const store = createStore(
    rootReducer(history),
    initialState,
    applyMiddleware(routerMiddleware(history), api)
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept("../reducers", () => {
      store.replaceReducer(rootReducer(history));
    });
  }
  const persiststore = persistStore(store);
  return { store, persiststore };
};

export default configureStore;